
import HowTo from './misc/HowTo';
import Methodology from './misc/Methodology';
import HPIRevisions from './misc/HPIRevisions';

const BASE_URL = 'https://ottaproperty.co.uk/blog/';

const createPost = (id, Component, link, title, image) => ({
  id,
  Component,
  link,
  title,
  image,
  ...((Component === HowTo || Component === HPIRevisions) && { props: { url: `${BASE_URL}${link}` } })
});

const Posts = [

  createPost(
    5,
    HPIRevisions,
    'why-the-ons-hpi-keeps-getting-revised-down',
    'Why the ONS HPI keeps getting revised down',
    'blog_images/hpi_revisions/newbuild_registration_lag.png'
  ),
  createPost(
    4,
    Methodology,
    'methodology',
    'Methodology',
    'blog_images/july_index/england_years.png'
  )
];

export default Posts;